import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'

import BookkeepingManagerDetailsViewModel from '../BookkeepingManagerDetailsViewModel'
import { timeago } from 'utils/date-util'
import BookkeepingPendingAction, {
  BookkeepingManagerAction,
} from 'admin/bookkeeping/BookkeepingPendingAction'
import { match } from 'utils/pattern-match-util'

import styles from './DetailsContent.sass'

interface DetailsContentProps {
  vm: BookkeepingManagerDetailsViewModel
}

export default observer(function DetailsContent({ vm }: DetailsContentProps) {
  return (
    <div className={styles.root}>
      <h2 className={styles.title}>{vm.bookkeepingPendingAction.jobName}</h2>
      <div className={styles.content}>
        <ContentItem label="Job ID">
          {vm.bookkeepingPendingAction.jobShortId}
        </ContentItem>
        <ContentItem label="Company ID">
          {vm.bookkeepingPendingAction.platformConnection?.displayId ?? 'N/A'}
        </ContentItem>
        <ContentItem label="Company Name">
          {vm.bookkeepingPendingAction.platformConnection?.displayName ?? 'N/A'}
        </ContentItem>
        <ContentItem label="Method">
          {vm.bookkeepingPendingAction.displayAccessMethod}
        </ContentItem>
        <ContentAction vm={vm.bookkeepingPendingAction} />
        <ContentItem label="Time in action">
          {timeago(vm.bookkeepingPendingAction.datePendingSince, 'long')}
        </ContentItem>
        <ContentInstructions action={vm.bookkeepingPendingAction} />
      </div>
    </div>
  )
})

interface ContentActionProps {
  vm: BookkeepingPendingAction
}

function ContentAction({ vm }: ContentActionProps) {
  return (
    <>
      <div className={styles.label}>Action</div>
      <div
        className={cx(
          styles.value,
          styles[`action-${formatActionSingleWorld(vm.action)}`],
        )}
      >
        {vm.displayAction}
      </div>
    </>
  )
}

interface ContentItemProps {
  label: string
  children?: React.ReactNode
  danger?: boolean
}

function ContentItem({ label, danger, children }: ContentItemProps) {
  return (
    <>
      <div className={styles.label}>{label}</div>
      <div className={cx(styles.value, danger && styles.danger)}>
        {children}
      </div>
    </>
  )
}

interface InstructionsProps {
  action: BookkeepingPendingAction
}

function ContentInstructions({ action }: InstructionsProps) {
  const content = match(action.action, {
    [BookkeepingManagerAction.ConfirmAccess]: () => (
      <>
        <p>{action.platformConnection?.helpText}</p>
        <br />
        <p>This will allow the Pro to start the bookkeeping.</p>
      </>
    ),
    [BookkeepingManagerAction.Unspecified]: () => <>Unspecified</>,
  })

  return <ContentItem label="Instructions">{content}</ContentItem>
}

function formatActionSingleWorld(action: BookkeepingManagerAction) {
  return match(action, {
    [BookkeepingManagerAction.ConfirmAccess]: () => 'confirm-access',
    [BookkeepingManagerAction.Unspecified]: () => '',
  })
}
